import {TABLE_AREA_Z_INDEX} from '@constant/system';
import {TABLE_MESSAGE_DURATION_MS} from '.';
import {ACTION_BUTTON_Z_INDEX} from '../ActionButtons';
import {GAME_TABLE_MARGIN_PX} from '@constant/game';
const IN_APP_BROWSER_ADJUSTMENT = 30;

const desktop = theme => {
  const {toVW} = theme;
  return {
    container: {
      position: 'relative',
    },
    tableAreaSection: {
      top: 0,
    },
    canvasArea: {},
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    singleTableContainer: {
      position: 'relative',
      width: `calc(100vw + ${2 * GAME_TABLE_MARGIN_PX}px)`,
      padding: [0, GAME_TABLE_MARGIN_PX],
      flexShrink: 0,
      overflowY: 'visible',
      overflowX: 'clip',
      display: 'flex',
      alignItems: 'center',
    },
    gameInfoContainer: {
      zIndex: 1,
      position: 'absolute',
      top: 0,
      left: GAME_TABLE_MARGIN_PX,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      columnGap: '10px',
      '&.isInAppBrowser': {
        top: IN_APP_BROWSER_ADJUSTMENT,
      },
      '&.hidden': {
        opacity: 0,
      },
    },
    container: {
      width: '100%',
      position: 'relative',
    },
    canvasArea: {
      position: 'absolute',
      zIndex: 1,
      pointerEvents: 'none',
      left: '50%',
      top: '50%',
      // TODO offset the top:-50 and make it in the middle of container
      transform: 'translate(-50%, -50%)',
    },
    connectionModalTitle: {
      fontSize: 20,
    },
    connectionSpinContainer: {
      marginTop: 20,
      width: '100%',
    },
    spinIcon: {
      color: 'white',
      fontSize: 35,
    },
    spinContainer: {
      background: 'rgb(0 0 0 / 50%)',
      width: '100vw',
      height: '100vh',
      position: 'fixed',

      zIndex: 30000,
      top: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    loadingText: {
      marginBottom: '10px',
      fontSize: 16,
    },
    debugButton: {
      '&.ant-btn': {
        background: 'grey',
        padding: 0,
        height: 20,
      },
    },
    tableAreaSection: {
      // margin: 'auto',
      position: 'relative',
      // top: -50,
      '&.isIphoneSE': {
        top: -14,
      },
      '&.isIphone13': {
        top: -10,
      },
      '&.isIphone13Mini': {
        top: -20,
      },
      '&.isIphone14Pro': {
        top: -20,
      },
      '&.isInAppBrowser': {
        top: IN_APP_BROWSER_ADJUSTMENT,
      },
      '&.isDebug': {
        background: 'grey',
        top: IN_APP_BROWSER_ADJUSTMENT,
      },
    },
    actionButtonSection: {
      position: 'fixed',
      bottom: 'var(--merchant-bottom-inset, 0px)',
      width: '100%',
      zIndex: TABLE_AREA_Z_INDEX.ACTION_animations,
    },
    waitList: {
      position: 'fixed',
      bottom: 'var(--merchant-bottom-inset, 0px)',
      width: '100%',
    },
    '@keyframes slideDown': {
      '0%': {
        transform: 'translate(0, 0)',
        opacity: 1,
      },
      '20%': {
        transform: 'translate(0%, 50%)',
        opacity: 0.5,
      },
      '100%': {
        transform: 'translate(0%, 100%)',
        opacity: 0, // Fade out at the end
      },
    },
    slideDownAnimation: {
      animation: '$slideDown 300ms ease-out forwards',
    },
    '@keyframes fadeOut': {
      '0%': {
        opacity: 1,
      },
      '100%': {
        opacity: 0,
      },
    },
    tableMessage: {
      width: '100%',
      height: 44,
      lineHeight: '44px',
      background: 'radial-gradient(#858585, #363C47, #202633)',
      top: '10%',
      left: '50%',
      transform: 'translateX(-50%)',
      textAlign: 'center',
      position: 'absolute',
      zIndex: TABLE_AREA_Z_INDEX.TABLE_MESSAGE,
      animation: `$fadeOut ${TABLE_MESSAGE_DURATION_MS}ms ease-in`,
    },
    sitOutModalContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    forceQuitModal: {
      borderRadius: 15,
      background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #202633',
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10)',
      width: 266,
      position: 'absolute',
      textAlign: 'center',
      top: '50%',
      left: '50%',
      padding: [20, 20],
      transform: 'translate(-50%, -50%)',
      zIndex: ACTION_BUTTON_Z_INDEX.MODAL,
      opacity: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '& button': {
        marginTop: 15,
      },
    },
    clockImage: {
      height: 121,
      width: 115,
      marginBottom: 20,
    },
    afkMessage: {
      padding: [0, 15],
    },
    rejoinRoomButton: {
      width: 'fit-content',
      height: '38px !important',
      border: 'none',
    },
    hidden: {
      visibility: 'hidden',
      opacity: 0,
    },
    hiddenClickable: {
      opacity: 0,
    },
    extendTimerModal: {
      position: 'absolute',
      zIndex: 1,
      top: 30,
      right: 0,
    },
    roomExpiredModal: {
      extend: 'forceQuitModal',
    },
    remainTimeDiv: {
      position: 'absolute',
      top: '50px',
      right: 10,
      textAlign: 'end',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    fullScreenLoading: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      zIndex: 9999,
      flexDirection: 'column',
    },
    transparentButton: {
      height: 30,
      backgroundColor: 'rgba(54, 202, 0, 0.46)',
      boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
      borderRadius: 10,
      border: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.textColor,
      position: 'absolute',
      left: '50%',
      bottom: '10%',
      transform: 'translateX(-50%)',
      '&.ant-btn': {
        padding: [0, 10],
      },
      '&.ant-btn:hover, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), rgba(54, 202, 0, 0.46)',
        boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
        border: 'none',
        color: theme.textColor,
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
